module.exports = __webpack_public_path__ + "img/icon_coordinates3.cf3c3a06.png";